import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './InviteAgentModal.scss';
import GooglePlaceAutocompleteInput from "../GooglePlaceAutocompleteInput";

export default class InviteAgentModal extends Component {
    static get propTypes() {
        return {
            tag: PropTypes.string,
            cityState: PropTypes.string,
            name: PropTypes.string,
            realtorId: PropTypes.number,
            onModalClose: PropTypes.function,
            buyPriceRanges: PropTypes.array,
        };
    }

    fullNamePattern = /^([\w]{3,})+\s+([\w\s]{3,})+$/i;

    constructor(props) {
        super(props);

        this.state = {
            buy: false,
            firstName: props.name ? getFirstName(props.name) : '',
            phone: '',
            email: '',
            fullName: '',
            address: '',
            homeType: '',
            priceRange: '',
            emailError: false,
            addressError: false,
            fullNameError: false,
            phoneError: false,
            homeTypeError: false,
            priceRangeError: false
        };
    }

    notValidEmail(value) {
        return !isValidEmailAddress(value);
    }

    handleSubmit = event => {
        if (this.notValidEmail(this.state.email)) {
            this.setState({emailError: true});
        }
        if (!this.state.buy && !isValidAddress(this.state.address)) {
            this.setState({addressError: true});
        }
        if (!this.fullNamePattern.test(this.state.fullName)) {
            this.setState({fullNameError: true});
        }
        if (!this.state.phone || returnNumbersOnly(this.state.phone).length !== 10) {
            this.setState({phoneError: true});
        }
        if (!this.state.homeType) {
            this.setState({homeTypeError: true});
        }
        if (this.state.buy && !this.state.priceRange) {
            this.setState({priceRangeError: true});
        }
        if (this.state.fullNameError || this.state.addressError || this.state.emailError || this.state.phoneError) {
            event.preventDefault();
        }
    };

    handleModalClose = () => {
        if (this.props.onModalClose) {
            this.props.onModalClose();
        }
    };

    render() {
        const {
            buy, firstName, phone, email, fullName, address, homeType, priceRange,
            emailError, addressError, fullNameError, phoneError, homeTypeError, priceRangeError
        } = this.state;
        const {tag, cityState, realtorId} = this.props;
        return (
            <div className="invite-agent-modal modal nu-modal fade mobile-full-screen">
                <div className="modal-dialog">
                    <div className="modal-content success">
                        <div>
                            <div className="modal-div">
                                <form action="create-draft-request2" target='_parent' method="POST" className="contact-form invite-agent-popup"
                                    onSubmit={this.handleSubmit}>
                                    <input type="hidden" name="dlink" value="true"/>
                                    <input type="hidden" name="tag" value={tag ? tag : ''}/>
                                    <input type="hidden" name="location" value={cityState ? cityState : ''}/>
                                    <input type="hidden" name="realtorId" value={realtorId ? realtorId : null}/>
                                    <div className="contact-title">Let’s introduce you to {firstName}</div>
                                    <div className="contact-subtitle">UpNest Advisors will reach out to verify your details, answer any questions you may have and introduce you to {firstName}.</div>

                                    <div className="float-label-div">
                                        <img src={global.imageBaseUrl + 'buysell/svg/user.svg'} alt="User icon"/>
                                        <input type="text" name="name" id="fullname-input"
                                            className={"form-control required input-lg" + (fullName ? ' floating' : '')}
                                            minwords="2"
                                            minLength="5"
                                            maxLength="100"
                                            onInput={event => this.setState({
                                                fullName: event.target.value,
                                                fullNameError: false
                                            })}/>
                                        <label htmlFor="fullname-input"
                                            className={"float-label" + (fullName ? ' collapsed' : '')}>Full Name</label>
                                        {fullNameError && (
                                            <label className="error">Please enter full name.</label>
                                        )}
                                    </div>
                                    <div className="float-label-div">
                                        <img src={global.imageBaseUrl + 'buysell/svg/email.svg'} alt="Email icon"/>
                                        <input type="email" name="email" id="email-input"
                                            className={"form-control email required input-lg" + (email ? ' floating' : '')}
                                            onInput={event => this.setState({
                                                email: event.target.value,
                                                emailError: false
                                            })}/>
                                        <label htmlFor="email-input"
                                            className={"float-label" + (email ? ' collapsed' : '')}>Email</label>
                                        {emailError && (
                                            <label className="error">Please enter a valid email address.</label>
                                        )}
                                    </div>
                                    <div className="float-label-div">
                                        <img src={global.imageBaseUrl + 'buysell/svg/phone.svg'} alt="Phone icon"/>
                                        <input maxLength="14" onKeyUp="phoneFormat(this, event)" type="tel" name="phone"
                                            id="phone-input"
                                            className={"form-control phoneUS required input-lg" + (phone ? ' floating' : '')}
                                            value={phone}
                                            onInput={event => this.setState({
                                                phone: returnPhoneFormat(event.target.value),
                                                phoneError: false
                                            })}
                                        />
                                        <label htmlFor="phone-input"
                                            className={"float-label" + (phone ? ' collapsed' : '')}>10-Digit Phone</label>
                                        {phoneError && (
                                            <label className="error">Please enter a valid phone.</label>
                                        )}
                                    </div>
                                    <div className="float-label-div">
                                        <img className="home-type-icon" src={global.imageBaseUrl + 'buysell/svg/single-family.svg'} alt="Home icon"/>
                                        <select name="homeType" id="home-type-select" value={homeType}
                                                className="form-control required input-lg home-type-select"
                                                style="padding: 0; text-indent: 40px;"
                                                onChange={event => this.setState({
                                                    homeType: event.target.value,
                                                    homeTypeError: false
                                                })}
                                        >
                                            <option value="">Home Type</option>
                                            <option value="Single Family">Single Family</option>
                                            <option value="Condominium">Condominium</option>
                                            <option value="Townhouse">Townhouse</option>
                                            <option value="Multi-Family">Multi-Family</option>
                                            <option value="Land">Vacant Lot/Other</option>
                                            <option value="Commercial">Commercial</option>
                                        </select>
                                        <label className="sr-only" htmlFor="home-type-select">Select home type</label>
                                        {homeTypeError && (
                                            <label className="error">Please select home type.</label>
                                        )}
                                    </div>
                                    <div style="font-size: 16px; letter-spacing: 0.3px; margin: 20px 0;display: flex">
                                        <div className="pretty-sell-buy" style="display: inline-block">
                                            <div className="pretty p-svg p-curve">
                                                <input type="radio" name="requestType" value="sell" checked={!buy}
                                                    onChange={() => this.setState({buy: false})}/>
                                                <div className="state p-primary">
                                                    <svg className="svg svg-icon" viewBox="0 0 20 20">
                                                        <path d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z" style="stroke: white;fill:white;"/>
                                                    </svg>
                                                    <label>I&apos;m selling</label>
                                                </div>
                                            </div>
                                            <div className="pretty p-svg p-curve">
                                                <input type="radio" name="requestType" value="buy" checked={buy}
                                                    onChange={() => this.setState({
                                                        buy: true,
                                                        addressError: false
                                                    })}
                                                />
                                                <div className="state p-primary">
                                                    <svg className="svg svg-icon" viewBox="0 0 20 20">
                                                        <path d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z" style="stroke: white;fill:white;"/>
                                                    </svg>
                                                    <label>I&apos;m buying</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {buy ? (
                                        <div className="float-label-div">
                                            <img src={global.imageBaseUrl + 'buysell/svg/price-tier1.svg'} alt="Price icon"/>
                                            <select name="priceRange"
                                                className="form-control required"
                                                value={priceRange}
                                                style="padding: 0; text-indent: 40px;"
                                                onChange={e => this.setState({
                                                    priceRange: e.target.value,
                                                    priceRangeError: false
                                                })}
                                            >
                                                <option value="">What is your price range?</option>
                                                {this.props.buyPriceRanges.map(buyPriceRange =>
                                                    <option key={buyPriceRange.rangeStr}
                                                        value={'' + (buyPriceRange.low || 0) + '-' + (buyPriceRange.high || (buyPriceRange.low * 2))}
                                                    >
                                                        {buyPriceRange.rangeStr}
                                                    </option>
                                                )}
                                            </select>
                                            {priceRangeError && (
                                                <label className="error">Please select your price range</label>
                                            )}
                                        </div>
                                    ) : (
                                        <div className={"float-label-div address-div"}>
                                            <img src={global.imageBaseUrl + 'buysell/svg/address.svg'} alt="Address icon"/>

                                            <GooglePlaceAutocompleteInput
                                                id="address"
                                                name="address"
                                                className={"form-control required validAddress input-lg" + (address ? ' floating' : '')}
                                                placeholder=""
                                                value={address}
                                                onChange={({target: {value}}) =>
                                                    this.setState({
                                                        address: value,
                                                        addressError: false
                                                    })
                                                }
                                                onInput={({target: {value}}) =>
                                                    this.setState({
                                                        address: value
                                                    })
                                                }
                                                onPlaceChanged={(input, place) => {
                                                    input.value = input.value.replace(/\s*,\s*(USA|United States)$/, '');
                                                    this.setState({
                                                        address: input.value,
                                                        addressError: false
                                                    });
                                                    $(input).trigger('focusout');
                                                }}
                                            />
                                            <label htmlFor="address"
                                                className={"float-label" + (address ? ' collapsed' : '')}>Selling Property Address</label>
                                            {addressError && (
                                                <label className="error">Please enter a valid full address, e.g. 1 Main St, Los Angeles, CA</label>
                                            )}
                                        </div>
                                    )}

                                    <div className="contact-action-buttons clearfix">
                                        <button type="submit" id="inviteAgentSubmit" className="nextStep btn btn-lg btn-default rounded orange pull-right">Submit <i className="icon-arrow-direct-right"/></button>
                                        <button
                                            className="btn btn-lg btn-default cancel-button rounded outline gray pull-right"
                                            onClick={() => {
                                                this.handleModalClose();
                                            }}
                                            type="button">Cancel</button>
                                    </div>
                                    <div className="by-clicking" style="margin-bottom: 7px">
                                        By clicking &quot;Submit&quot;, I consent to UpNest&apos;s <a href="https://www.upnest.com/re/terms" target="_blank" rel="noreferrer">Terms of Service</a> and <a href="https://www.realtor.com/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
